import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import './assets/scss/app.scss'
import VueSocialSharing from 'vue-social-sharing'
import VueMeta from "vue-meta";

Vue.use(VueMeta).use(VueSocialSharing);
Vue.config.productionTip = false;

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')
     